import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout.tsx";
import { Card } from "@/components/ui/card.tsx";
import { MarkdownContent } from "@/components/MarkdownContent.tsx";

interface ContactsProps {
  content: string;
}

export default function Contacts({ content }: ContactsProps) {
  return (
    <BizminerLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Contacts</h1>
          <p className="mt-1 text-muted-foreground">
            Your team and support contacts.
          </p>
        </div>

        <Card className="p-6 overflow-x-auto">
          <MarkdownContent content={content} className="[&_table]:w-full" />
        </Card>
      </div>
    </BizminerLayout>
  );
}
